import { parseISO } from 'date-fns'

export function getTimezoneIgnoredDate(date: string) {
  // Parse the date and extract just the date components
  const parsed = parseISO(date)
  const year = parsed.getUTCFullYear()
  const month = parsed.getUTCMonth()
  const day = parsed.getUTCDate()

  // Create a new date at noon UTC for the same date
  // This ensures the date shown will be the same regardless of timezone
  return new Date(Date.UTC(year, month, day, 12, 0, 0))
}

export function stripTimezoneFromDate(date: Date | null) {
  if (!date) {
    return date
  }

  const year = date.getFullYear()
  const month = date.getMonth()
  const day = date.getDate()

  // Create the date at noon UTC
  // This ensures consistent date handling across timezones
  const utcDate = new Date(Date.UTC(year, month, day, 12, 0, 0))

  return utcDate
}
